import React, { createContext, useEffect, useState } from "react";

export const ThemeContext = createContext();
const ThemeContextProvider = (props) => {
   const body = document.querySelector("body");
    const [windowWidth, setWindowWidth] = useState(0);
    const [windowHeight, setWindowHeight] = useState(0);
    const [sideBarStyle, setSideBarStyle] = useState({ value: "full", label: "Full",});
    const [sidebariconHover, setSidebariconHover] = useState(false);
    const [background, setBackground] = useState({value: "light",label: "Light",});
    const [sidebarLayout, setSidebarLayout] = useState({ value: "vertical", label: "Vertical",});
    const [menuToggle, setMenuToggle] = useState(false);

    const changeSideBarLayout = (name) => {
      if (name.value === "horizontal") {
        if (sideBarStyle.value === "overlay") {
          setSidebarLayout(name);
          body.setAttribute("data-layout", name.value);
          setSideBarStyle({ value: "full", label: "Full" });
          body.setAttribute("data-sidebar-style", "full");
        } else {
          setSidebarLayout(name);
          body.setAttribute("data-layout", name.value);
        }
      } else {
        setSidebarLayout(name);
        body.setAttribute("data-layout", name.value);
      }
    };

    const openMenuToggle = () => {
      sideBarStyle.value === "overly"
        ? setMenuToggle(true)
        : setMenuToggle(false);
    };

    const changeBackground = (name) => {
      body.setAttribute("data-theme-version", name.value);
      setBackground(name);   
    };

    const ChangeIconSidebar = (value) => {
      if(sideBarStyle.value==="icon-hover"){
        if(value){
          setSidebariconHover(true);
        }else{
          setSidebariconHover(false);
        }
      }
    }
  
	
    useEffect(() => {
		const body = document.querySelector("body");
		let resizeWindow = () => {
			setWindowWidth(window.innerWidth);
			setWindowHeight(window.innerHeight);
			window.innerWidth >= 768 && window.innerWidth < 1300
			? body.setAttribute("data-sidebar-style", "mini")
			: window.innerWidth <= 768
			? body.setAttribute("data-sidebar-style", "overlay")
			: body.setAttribute("data-sidebar-style", "full");
		};
        body.setAttribute("data-typography", "poppins");
        body.setAttribute("data-theme-version", "light");
       // body.setAttribute("data-theme-version", "dark");
        body.setAttribute("data-layout", "vertical");
        body.setAttribute("data-nav-headerbg", "color_1");
        body.setAttribute("data-headerbg", "color_1");
        body.setAttribute("data-sidebar-style", "overlay");
        body.setAttribute("data-sibebarbg", "color_1");
        body.setAttribute("data-primary", "color_1");
        body.setAttribute("data-sidebar-position", "fixed");
        body.setAttribute("data-header-position", "fixed");
        body.setAttribute("data-container", "wide");
        body.setAttribute("direction", "ltr");
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);
    return (
    <ThemeContext.Provider
      value={{
        body,
        windowWidth,
        windowHeight,
        background,
        changeBackground,
        sidebariconHover,
        sidebarLayout,
        changeSideBarLayout,
        ChangeIconSidebar,
        menuToggle,
        openMenuToggle

	}}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;